{
  "version": 1,
  "asset_id": "a89d32e4-278b-4986-96a6-d9a752697c8d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/a89d32e4-278b-4986-96a6-d9a752697c8d/loc-georgetown-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/a89d32e4-278b-4986-96a6-d9a752697c8d/loc-georgetown-1280.webp",
  "original_filename": "loc-georgetown-1280.webp",
  "size": 134110,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:27Z"
}
